import axios from 'axios'
import Environments from '../environments/Environment';

var http = null;

class APIProvider {
    constructor() {
        http = axios.create({
            baseURL: Environments.BASE_URL,
            headers: { 'Content-Type': 'application/json' }
        })

        // http.defaults.headers.common['Content-Type'] = '';
    }

    login(data) {
        return new Promise((success, error) => {
            http.post('/session/login', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else
                    error(result.data);
            });
        });
    }

    logout() {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.get('/session/logout').then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else
                    error(result.data);
            });
        });
    }

    register(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/session/register', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else
                    error(result.data);
            });
        });
    }

    recoverPassword(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/session/recover-password', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else
                    error(result.data);
            });
        });
    }

    validateRecoveryCode(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/session/validate-recovery-code', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else
                    error(result.data);
            });
        });
    }

    updatePassword(data) {
        http.defaults.headers.common['session'] = localStorage.getItem('session');
        return new Promise((success, error) => {
            http.post('/session/update-password', data).then((result) => {
                if (result.data.status == 1)
                    success(result.data);
                else
                    error(result.data);
            });
        });
    }
}

export default new APIProvider();


// WEBPACK FOOTER //
// ./src/services/Session.js